import customerSpecifyPricing from "../../views/csp/Index.vue";

const CustomerSpecifyPricingRoute = [
  {
    path: "/customer-specify-pricing",
    name: "customerSpecifyPricing",
    component: customerSpecifyPricing,
  },
];

export default CustomerSpecifyPricingRoute;
